module.exports = new __parcel__URL__("atlassianLogo.598181d7.svg").toString();